import { PostRequest } from "./requests";

export const getGeneralAttributes = async () => {
    return await PostRequest("/api/general_attributes/get", {});
};

export const updateGeneralAttributes = async (data: any) => {
    return await PostRequest("/api/general_attributes/update", data);
};

export const createGeneralAttributes = async (data: any) => {
    return await PostRequest("/api/general_attributes/create", data);
};
